module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/home-front-service-lvl3-50.4704c7d8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/home-front-service-lvl3-50.png
// module id = 3541
// module chunks = 11